import { useMemo } from 'react';
import { CreditCard } from 'lucide-react';
import { StepHeader } from '~/components/forms/StepHeader';
import { TuitionChunk } from '~/components/form-chunks/TuitionChunk';

interface AppTuitionStepProps {
  formData: any;
  updateFormData: (path: string, value: any) => void;
}

export function AppTuitionStep({ formData, updateFormData }: AppTuitionStepProps) {
  const availableOptions = formData?.availableOptions || {};
  const tuitionOptions = availableOptions.tuitionOptions || [];
  const paymentOptions = availableOptions.paymentOptions || [];
  const schoolYear = formData?.schoolYear || {};
  const schoolYearStartDate = schoolYear.startDate || null;
  const schoolYearEndDate = schoolYear.endDate || null;

  const tuitionPreferences = useMemo(() => formData?.tuitionPreferences || {}, [formData?.tuitionPreferences]);

  const enrollingStudents = useMemo(() => {
    const persisted = (formData?.students || []).filter((s: any) => s.firstName || s.lastName);
    const newOnes = (formData?.newStudents || []).filter((s: any) => s.firstName || s.lastName);
    return [...persisted, ...newOnes].map((s: any) => ({
      id: s.studentEnrollmentId || s.tempId,
      firstName: s.firstName,
      lastName: s.lastName,
      type: 'new' as const,
    }));
  }, [formData?.students, formData?.newStudents]);

  const handleUpdate = (updatedTuitionPreferences: any) => {
    updateFormData('tuitionPreferences', updatedTuitionPreferences);
  };

  return (
    <div className="space-y-6">
      <StepHeader
        icon={CreditCard}
        title="Tuition & Payment"
        description="Select a tuition option for each student and a payment plan for your family."
      />

      <TuitionChunk
        enrollingStudents={enrollingStudents}
        tuitionOptions={tuitionOptions}
        paymentOptions={paymentOptions}
        tuitionPreferences={tuitionPreferences}
        onUpdate={handleUpdate}
        schoolYearStartDate={schoolYearStartDate}
        schoolYearEndDate={schoolYearEndDate}
      />
    </div>
  );
}
